"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmoothStreamManifestParser = (function () {
    function SmoothStreamManifestParser() {
    }
    SmoothStreamManifestParser.prototype.parseXml = function (url, xmlDocument) {
        var smoothStreamingMediaResult = xmlDocument.evaluate('//SmoothStreamingMedia', xmlDocument, null, XPathResult.ANY_TYPE, null);
        var smoothStreamingMediaNode = smoothStreamingMediaResult.iterateNext();
        if (!smoothStreamingMediaNode) {
            return null;
        }
        return {
            baseUrl: this.getBaseUrl(url),
            duration: parseInt(smoothStreamingMediaNode.getAttribute('Duration'), 10) || 0,
            lookAheadFragmentCount: parseInt(smoothStreamingMediaNode.getAttribute('LookAheadFragmentCount'), 10) || 0,
            startTime: this.getVideoStartTime(xmlDocument, smoothStreamingMediaNode),
            textTracks: this.getTextTracks(xmlDocument, smoothStreamingMediaNode),
            audioTracks: this.getAudioTracks(xmlDocument, smoothStreamingMediaNode),
        };
    };
    SmoothStreamManifestParser.prototype.getBaseUrl = function (url) {
        var extensionMatch = /\.ism(l)?/.exec(url);
        var extensionLength = extensionMatch[0].length;
        return url.substring(0, extensionMatch.index + extensionLength);
    };
    SmoothStreamManifestParser.prototype.getVideoStartTime = function (xmlDocument, smoothStreamingMediaNode) {
        var videoTracksResult = xmlDocument.evaluate(this.matchStreamIndex('video'), smoothStreamingMediaNode, null, XPathResult.ANY_TYPE, null);
        var videoTrackNode = videoTracksResult.iterateNext();
        var chunksResult = xmlDocument.evaluate('c', videoTrackNode, null, XPathResult.ANY_TYPE, null);
        var firstVideoChunk = chunksResult.iterateNext();
        return parseInt(firstVideoChunk.getAttribute('t'), 10) || 0;
    };
    SmoothStreamManifestParser.prototype.getTextTracks = function (xmlDocument, smoothStreamingMediaNode) {
        return this.extractTracks(xmlDocument, smoothStreamingMediaNode, 'text');
    };
    SmoothStreamManifestParser.prototype.getAudioTracks = function (xmlDocument, smoothStreamingMediaNode) {
        return this.extractTracks(xmlDocument, smoothStreamingMediaNode, 'audio');
    };
    SmoothStreamManifestParser.prototype.extractTracks = function (xmlDocument, smoothStreamingMediaNode, trackType, expandChunks) {
        if (expandChunks === void 0) { expandChunks = false; }
        var tracks = new Array();
        var tracksResult = xmlDocument.evaluate(this.matchStreamIndex(trackType), smoothStreamingMediaNode, null, XPathResult.ANY_TYPE, null);
        var trackNode = tracksResult.iterateNext();
        while (trackNode) {
            var qualityLevelResult = xmlDocument.evaluate('QualityLevel', trackNode, null, XPathResult.ANY_TYPE, null);
            var qualityLevelNode = qualityLevelResult.iterateNext();
            var chunks = new Array();
            if (expandChunks) {
                var chunksResult = xmlDocument.evaluate('c', trackNode, null, XPathResult.ANY_TYPE, null);
                var chunkNode = chunksResult.iterateNext();
                while (chunkNode) {
                    var chunk = {
                        duration: parseInt(chunkNode.getAttribute('d'), 10),
                    };
                    var chunkStartTime = parseInt(chunkNode.getAttribute('t'), 10);
                    if (chunkStartTime) {
                        chunk.startTime = chunkStartTime;
                    }
                    chunks.push(chunk);
                    chunkNode = chunksResult.iterateNext();
                }
            }
            tracks.push({
                type: trackNode.getAttribute('Type'),
                name: trackNode.getAttribute('Name'),
                language: trackNode.getAttribute('Language'),
                subtype: trackNode.getAttribute('Subtype'),
                chunks: parseInt(trackNode.getAttribute('Chunks'), 10),
                url: trackNode.getAttribute('Url'),
                qualityLevels: [
                    {
                        bitrate: parseInt(qualityLevelNode.getAttribute('Bitrate'), 10),
                        fourCC: qualityLevelNode.getAttribute('FourCC'),
                        chunks: chunks,
                    },
                ],
            });
            trackNode = tracksResult.iterateNext();
        }
        return tracks;
    };
    SmoothStreamManifestParser.prototype.matchStreamIndex = function (trackType) {
        return "//SmoothStreamingMedia/StreamIndex[@Type=\"" + trackType + "\"]";
    };
    return SmoothStreamManifestParser;
}());
exports.SmoothStreamManifestParser = SmoothStreamManifestParser;
